<template>
  <!--保函上传弹出框-->
  <el-dialog
    :visible.sync="uploadGuaranteeVisible"
    title="保函上传"
    :append-to-body="true"
    :close-on-click-modal="false"
    custom-class="customWidthUploadGuarantee"
    :before-close="close"
  >
  <div slot="title"><span style="font-size:18px">保函上传</span><span style="color:red;margin-left:15px">上传单个文件大小不超过10MB</span></div>
    <div class="spec-dialog">
      <!-- start -->
      <el-form label-position="top" size="mini" :model="mdAccessories"
               :validateOnRuleChange="false" ref="mdAccessoriesRef" :rules="rulesForm">
        <el-row :gutter="10" style="margin-bottom: 10px;margin-right: 15px">
          <el-row class="panel-top">
            <el-uploader
              strategyKey="1"
              class="drop1"
              multiple
              drag
              :http-request="upload"
              image-viewer
              :onPreview="handlePreview"
              :file-list="fileList"
              :before-upload="beforeAvatarUpload"
              :on-success="handleAvatarSuccess"
              :on-exceed="handleExceed"
            >
              拖动照片到这里或点击此处
            </el-uploader>
          </el-row>
<!--          <el-col :span="10" style="margin-top: 2px">
            <el-form-item prop="documentCode" label="保函分类">
              <el-select v-model="mdAccessories.documentCode" class="form-select" clearable placeholder="">
                <el-option
                  v-for="item in documentCodeList"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10" style="margin-top: 2px">
            <el-form-item prop="sourceSystemType" label="业务环节">
              <el-select v-model="mdAccessories.sourceSystemType" class="form-select" clearable placeholder="">
                <el-option
                  v-for="item in sourceSystemTypeList"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4" style="margin-top: 2px">
            <el-form-item label=" ">
              <el-uploader
                class="upload-demo"
                strategyKey="1"
                multiple
                :http-request="upload"
                image-viewer
                :onPreview="handlePreview"
                :file-list="fileList"
                :before-upload="beforeAvatarUpload"
                :on-success="handleAvatarSuccess"
                :on-exceed="handleExceed"
              >
              <el-button size="small" type="primary">点击上传</el-button>
              </el-uploader>
            </el-form-item>
          </el-col>-->
        </el-row>
<!--         <el-row style="color:red;" type="flex" justify="end">
          上传单个文件大小不超过10MB
        </el-row> -->
        <el-row style="margin-top: 100px;margin-bottom: 10px">
          <el-table ref="multipleTable" :data="mdAccessoriesTableDataSource"  border style="width: 100%;height: 60%;min-height: 170px" >
            <el-table-column type="selection" width="40">
            </el-table-column>
            <el-table-column label="序号" type="index" width="50" align="center"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="attachmentName"  label="文件名" min-width="140" align="center"></el-table-column>
            <el-table-column prop="attachmentType" label="文件类型" min-width="130" align="center">
              <template slot-scope="scope">
                <el-select
                  :disabled="scope.row.status === 1"
                  size="mini"
                  v-model="scope.row.attachmentType"
                  clearable
                  default-first-option
                  @change="selectType(scope.row)"
                >
                  <el-option
                    v-for="item in fileTypeOptions"
                    :key="item.key"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="操作" min-width="210" align="center">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="primary"
                  :disabled="scope.row.status === 1"
                  @click="handleSubmit(scope.$index, scope.row)">提交</el-button>
                <a @click="handleDownload(scope.$index, scope.row)" class="li-style" style="margin-top: 0" :href="scope.row.fileKey == undefined ? '#' : 'http://124.70.141.71:10061/cts-file-service/cloud/filesystem/downloadFile/'+scope.row.fileKey">
                  <el-button
                    size="mini"
                   >下载</el-button>
                </a>
                <el-button
                  size="mini"
                  type="danger"
                  :disabled="scope.row.status === 1"
                  @click="handleDelete(scope.$index, scope.row)">删除</el-button>
              </template>
            </el-table-column>
            <el-table-column style="height: 50px" :show-overflow-tooltip="true" prop="attachmentTime" label="上传时间" min-width="150" align="center">
            </el-table-column>
          </el-table>
<!--          <hot-table
            ref="mdAccessoriesTableRef"
            :data-source="mdAccessoriesTableDataSource"
            :settings="mdAccessoriesTableSettings"
          >
            <hot-column :has-tip="true" data="attachmentName" title="文件名" width="150"></hot-column>
            <hot-column :has-tip="true" data="attachmentType" title="文件类型" width="150">
              <el-select-editor
                name="attachmentType"
                hot-editor
                clearable
              >
                <el-option
                  v-for="item in fileTypeOptions"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key"
                >
                </el-option>
              </el-select-editor>
            </hot-column>
            <hot-column :has-tip="true" data="action" title="操作" width="150">
            </hot-column>
            <hot-column :has-tip="true" data="attachmentTime" title="上传时间" date-format="YYYY-MM-DD HH:mm:ss" width="150"></hot-column>
          </hot-table>-->
        </el-row>
        <el-row type="flex" justify="center">
          <el-button size="small" type="primary" @click="handleAllSubmit">批量提交</el-button>
          <el-button size="small" type="primary" @click="close">取消</el-button>
        </el-row>
      </el-form>
      <!--  end -->
      <!-- table start -->
      <!-- table end -->
      <!-- 按钮 start -->
      <!-- 按钮 end -->
    </div>
  </el-dialog>
</template>

<script>

  import { queryMdAccessories } from '@/api/queryMainSystem'
  import { queryDictRows } from "@/api/commonService";
  import columnDeleteRenderer from "@/components/CustomRenderer/columnDeleteRenderer"
  import {manifestImport} from "@/api/common";
  import request from "@/utils/request";
  import axios from 'axios'
  export default {
    components: {
      column_delete_renderer: columnDeleteRenderer,
    },
    name: 'uploadGuaranteeUpBox',
    props: {
      uploadGuaranteeVisible: {
        default: false,
        type: Boolean
      },
      resultEbOrder: {},
    },
    watch: {
      uploadGuaranteeVisible() {
        if(this.uploadGuaranteeVisible){
          this.queryMdAccessories();
        }
      }
    },
    data() {
      return {
        data1: "1111",
        fileTypeOptions: [],
        fileList:[],
        fileListAll:[],
        //非空校验
        rulesForm: {
          documentCode: [{
            required: true,
            message: "保函分类不能为空",
            trigger: ['blur', 'change']
          }],
          sourceSystemType: [{
            required: true,
            message: "业务环节不能为空",
            trigger: ['blur', 'change']
          }],
          fileName: [{
            required: true,
            message: "请上传一个文件",
            trigger: ['blur', 'change']
          }]
        },
        ebOrderId: null,
        sourceId: null,
        documentCodeList: [],
        sourceSystemTypeList: [],
        mdAccessories: {
          documentCode: null,
          sourceSystemType: "O",
          fileName: null
        },
        // 表格数据
        mdAccessoriesTableDataSource: [],
        // 表格设置
        mdAccessoriesTableSettings: {
          height: 180,
          stretchH: 'all', // 根据宽度横向扩展，last:只扩展最后一列，none：默认不扩展
          ...this.$systemConfig.tableConfig,
          //showSelection: false //把checkBox隐藏
        },
        // 分页
        pageConfig: {
          layout: 'total, sizes, prev, pager, next, jumper',
          total: 0,
          pageSize: 10,
          pagerCount: 10,
          currentPage: 1,
          pageSizes: [10, 20, 50, 100]
        },
      }
    },
    async created() {
      await this.$permissions.clearCache();
      await this.$permissions.loadPermissions(this.$route.path);
      this.querySelectList();
      this.queryFileTypeOptions();
    },
    mounted() {
    },
    methods: {
      queryFileTypeOptions() {
        let self = this;
        queryDictRows("MD_CODE_DICT$EB_DOC_TYPE").then((res) => {
          let dict = [];
          res.MD_CODE_DICT$EB_DOC_TYPE.forEach((item) => {
            let param = {};
            param.key = item.key;
            param.value = item.value;
            param.count = 0;
            param.filterList = [];
            dict.push(param);
          });
          self.fileTypeOptions = dict;
          console.log("ebOrderStatusList", dict);
          // 数据字典
          self.$element.registDict({EB_DOC_TYPE: dict});
        });
      },
      onChange() {
      },
      handleAvatarSuccess() {
        this.imageViewerVisible = false;
      },
      handlePreview(file){
      },
      setEbOrderId(record) {
        this.ebOrderId = record.ebOrderId;
        this.sourceId = record.mfOrderId;
        console.log("ebOrderId:"+this.ebOrderId)
      },
      handleExceed(files, fileList) {
        console.log(fileList);
        console.log(files);
        files.forEach( item => {
          let table = {
            attachmentName: item.name,
            attachmentTypeCode: '',
            attachmentTypeName: '',
            attachmentTime: new Date().toLocaleString(),
            status: 0,
          }
          this.mdAccessoriesTableDataSource.push(table);
          let file ={
            file: item,
            action: "/api/cts-file-service/cloud/filesystem/uploadFile/1",
            filename: "file",
          }
          this.fileListAll.push(file);
        })
      },
      beforeRemove(file, fileList) {
        return this.$confirm(`确定移除 ${file.name}？`);
      },
      // pageSize 改变时会触发
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`)
        this.pageConfig.pageSize = val
        this.queryMdAccessories()
      },
      // currentPage 改变时会触发
      handleCurrentChange(val) {
        this.pageConfig.currentPage = val
      },
      //获取表格数据
      queryMdAccessories() {
        let param = {
          planId: this.sourceId
        };
        queryMdAccessories(param).then(res => {
          this.mdAccessoriesTableDataSource = [];
          res.records[0].records.forEach((item) => {
            if(item.appCode === "CTS_WEB"){
              let obj = {
                status: 1,
                attachmentName: item.attachmentName,
                attachmentTime: new Date(item.createTime).toLocaleString(),
                attachmentTypeCode: item.documentCode,
                fileKey: item.fileKey,
              }
              this.fileTypeOptions.forEach(type => {
                if(type.key === obj.attachmentTypeCode){
                  obj.attachmentType = type.value;
                }
              });
              this.mdAccessoriesTableDataSource.push(obj);
            }
          });
        });
        this.pageConfig.total = 5
      },
      //获取数据字典
      querySelectList() {
        queryDictRows('MD_CODE_DICT$EB_GUARANTEE_TYPE,MD_CODE_DICT$EB_TYPE').then(res => {
          let dictDocumentCode = []
          let dictSourceSystemType = []
          res.MD_CODE_DICT$EB_GUARANTEE_TYPE.forEach(item => {
            let param = {}
            param.name = item.value
            param.value = item.key
            dictDocumentCode.push(param)
          })
          this.documentCodeList = dictDocumentCode
          res.MD_CODE_DICT$EB_TYPE.forEach(item => {
            let param = {}
            param.name = item.value
            param.value = item.key
            dictSourceSystemType.push(param)
          })
          this.sourceSystemTypeList = dictSourceSystemType
          this.$hotTableUtils.registDict({ 'EB_DOCUMENT_CODE': dictDocumentCode })
          this.$hotTableUtils.registDict({ 'EB_SOURCE_SYSTEM_TYPE': dictSourceSystemType })
        })
      },
      //确认
      sure() {
        //非空校验
      },
      //关闭
      close() {
        this.$emit('update:uploadGuaranteeVisible',false)
        // this.$refs.upload.clearFiles()
        // this.$refs.mdAccessoriesRef.resetFields()
      },
      //子组件
      clickModule() {

      },
      selectType(row){
        console.log('row=>',row);
        this.fileTypeOptions.forEach(item => {
          if(item.value === row.attachmentType){
            row.attachmentTypeCode = item.key;
            row.attachmentTypeName = item.value;
          }
        });
      },
      handleDelete(index,row){
        console.log('index=>',index);
        console.log('row=>',row);
        /*this.fileListAll.forEach(item =>{
          if(item.file.name === row.attachmentName){
            this.fileListAll.detect(item);
          }
        });*/
        let mdAccessoriesTableDataSource1 = [];
        this.mdAccessoriesTableDataSource.forEach(item =>{
          if(item.attachmentTime !== row.attachmentTime){
            mdAccessoriesTableDataSource1.push(item);
          }
        });
        this.mdAccessoriesTableDataSource = mdAccessoriesTableDataSource1;
        let fileListAll1 = [];
        this.fileListAll.forEach(item =>{
          if(item.file.name !== row.attachmentName){
            fileListAll1.push(item);
          }
        });
        this.fileListAll = fileListAll1;
        this.$forceUpdate();
      },
      handleDownload(index,row){
        console.log(row.fileKey);
        if(!row.fileKey){
          this.$coreMethods.message("warning", "文件尚未提交！")
        }
        //this.$coreMethods.message("warning", "该功能尚未实现！");
      },
      handleAllSubmit(){
        let selects = this.mdAccessoriesTableDataSource;
        if(selects.length === 0){
          return this.$coreMethods.message("warning", "请上传文件");
        }
        let checkResult = false;
        selects.forEach(item =>{
          if(item.attachmentType=== "" || item.attachmentType=== undefined){
            checkResult = true;
          }
        });
        if(checkResult){
          return  this.$coreMethods.message("warning", "文件类型不能为空！");
        }
        console.log('selects=>',selects);
        let selects1= [];
        selects.forEach(row => {
          if(row.status ===0 ){
            selects1.push(row);
          }
        });
        if(selects1.length===0){
          this.$coreMethods.message("warning", "数据已经全部提交！请勿重复操作");
          return
        }
        selects1.forEach(row =>{
          this.fileListAll.forEach(item =>{
            if(item.file.name === row.attachmentName){
              let file = item
              let url = "/api/cts-file-service/cloud/filesystem/uploadFile/1?$upload_file_extra_planId="+this.sourceId+
                "&$upload_file_extra_orderId="+this.resultEbOrder.goOrderId+
                "&$upload_file_extra_sourceSystemType="+this.resultEbOrder.bizBigTypeCode+
                "&$upload_file_extra_documentCode="+row.attachmentTypeCode+
                "&$upload_file_extra_documentName="+row.attachmentTypeName+
                "&$upload_file_extra_sourceSystemId="+this.sourceId+
                "&$upload_file_extra_planType=MF"
              let param = new FormData()
              param.append('file', file.file, file.file.name)
              axios.post(url,param)
                .then(res=>{
                  console.log('res=>',res);
                  row.status = 1;
                  let result = JSON.parse(res.data.substring(res.data.indexOf("{"),res.data.indexOf("}"))+"}");
                  row.fileKey = result.fileKey===undefined? "#" : result.fileKey;
                  this.$forceUpdate();
                })
              this.fileList = []
            }
          });
        });
        this.$coreMethods.message("success", "批量提交成功！");
      },
      handleSubmit(index,row){
        if(row.attachmentType=== "" || row.attachmentType=== undefined){
          return  this.$coreMethods.message("warning", "文件类型不能为空！");
        }
        let file;
        this.fileListAll.forEach(item =>{
          if(item.file.name === row.attachmentName){
            file = item;
            file.type = row.attachmentType;
          }
        });
        let url = "/api/cts-file-service/cloud/filesystem/uploadFile/1?$upload_file_extra_planId="+this.sourceId+
          "&$upload_file_extra_orderId="+this.resultEbOrder.goOrderId+
          "&$upload_file_extra_sourceSystemType="+this.resultEbOrder.bizBigTypeCode+
          "&$upload_file_extra_documentCode="+row.attachmentTypeCode+
          "&$upload_file_extra_documentName="+row.attachmentTypeName+
          "&$upload_file_extra_sourceSystemId="+this.sourceId+
          "&$upload_file_extra_planType=MF"
        let param = new FormData()
        param.append('file', file.file, file.file.name)
        axios.post(url,param)
          .then(res=>{
            console.log('res=>',res);
            this.$coreMethods.message("success", "提交成功！");
            row.status = 1;
            let result = JSON.parse(res.data.substring(res.data.indexOf("{"),res.data.indexOf("}"))+"}");
            row.fileKey = result.fileKey===undefined? "#" : result.fileKey;
            this.$forceUpdate();
          })
        this.fileList = []

      },
      upload(file){
        //一个错误的请求不是真正的上传
        let url = "/api/cts-file-service/cloud/filesystem/uploadFile/1?$upload_file_extra_planId="+this.sourceId +"&$upload_file_extra_orderId="+this.ebOrderId +"&$upload_file_extra_sourceSystemType="+this.mdAccessories.documentCode+ "&$upload_file_extra_documentCode="+this.mdAccessories.sourceSystemType+"&$upload_file_extra_sourceSystemId="+this.sourceId+"&$upload_file_extra_planType=MF"
        let param = '';
        //let param = new FormData()
        //param.append('file', file.file, file.file.name)
        axios.post(url,param)
          .then(res=>{
            let table = {
              attachmentName: file.file.name,
              attachmentTypeCode: '',
              attachmentTypeName: '',
              attachmentTime: new Date().toLocaleString(),
              //attachmentTime: new Date().format('yyyy-MM-dd HH:mm:ss'),
              status: 0,
            }
            this.mdAccessoriesTableDataSource.push(table);
            console.log('res=>',res);
          })
        this.fileList = [];
        this.fileListAll.push(file);
      },
      beforeAvatarUpload(file) {
        if(this.mdAccessories.documentCode==null || this.mdAccessories.sourceSystemType == null){
          /*this.$message.error('保函类型和业务环节不能为空');
          return false;*/
        }
      }
    }
  }
</script>

<style scoped>
.spec-dialog{
  width: auto;
  height: 400px;
}
.drop1{
  width: 600px;
  height: 60px;
  line-height: 60px;
  margin: 0 auto;
  font-size: 20px;
  border-radius: 5px;
  text-align: center;
  color: #bbb;
  position: relative;
}
::v-deep .el-upload-dragger{
  width: 717px !important;
  height: 140px !important;
  margin-left:5px !important
}
::v-deep .drop1{
  margin: unset;
}
::v-deep .el-table--scrollable-x .el-table__body-wrapper {
    height: 150px;
}
::v-deep .el-table--border{
    min-height: 210px
}
;
</style>
